module.exports = __webpack_public_path__ + "static/whatch-now-d201563fb8cf7252bfd766d5c28dfab4.png";